import { filterL, go, head, map, mapL } from "fxjs/es";
import { CommonNS } from "../../../../../../Common/CommonNS.js";
import { PROCESSING_TASK } from "./const.js";
export const _handleTouchStartOnSelectorPathEl = (self, event) => {
  const translate_transforming = self._getTranslateTransformingThrowable();
  event.preventDefault();
  const { targetTouches: target_touches, changedTouches: changed_touches } =
    event;
  const target_touch_id_set = go(
    CommonNS.UtilNS.convertTouchListToGen(target_touches),
    mapL(({ identifier }) => identifier),
    (iter) => new Set(iter)
  );
  const touch = go(
    CommonNS.UtilNS.convertTouchListToGen(changed_touches),
    filterL(({ identifier }) => target_touch_id_set.has(identifier)),
    head
  );
  if (touch == null) {
    return;
  }
  const { identifier: touch_id, clientX: client_x, clientY: client_y } = touch;
  const els = go(
    self._els.entries(),
    filterL(([id]) => self._selected_el_ids.has(id)),
    map(([, { wrapper_el }]) => wrapper_el)
  );
  translate_transforming.start({
    x: client_x,
    y: client_y,
    els,
  });
  self._processing_task = PROCESSING_TASK.TRANSLATE_TRANSFORMING;
  self._translate_transforming_touch_id = touch_id;
};
